import { Spinner } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './ComplainsModalLoader.css';

export const ComplainsModalLoader: FC = () => {
  return (
    <div className={styles['container']}>
      <Spinner size={40} />
    </div>
  );
};
